import { requestToken, request } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/report`;

class ReportManageServices {
    async getReportList(fromDate, toDate, userId, page = 1, limit = 10, searchFilter = "") {
    try {
      const params = new URLSearchParams({ fromDate, toDate, page, limit, searchFilter });
      if (userId) params.append("userId", userId);
      const response = await requestToken.get(`${API_ROUTE}/get-report-list?${params.toString()}`);
      return response;
    } catch (error) {
      console.error("Error in getReportList:", error);
      throw error;
    }
  }

  async getReportDateDetail(txnDate, userId) {
    try {
      const params = new URLSearchParams({ txnDate });
      if (userId) params.append("userId", userId);
      const response = await requestToken.get(
        `${API_ROUTE}/get-report-date-detail?${params.toString()}`,
      );
      return response;
    } catch (error) {
      console.error("Error in getReportDateDetail:", error);
      throw error;
    }
  }
}

export default ReportManageServices;